const promises = [
  {
    icon: 'ri-leaf-line',
    title: '100% Puur Natuurlijk',
    desc: 'Alleen ingrediënten rechtstreeks uit de natuur — geen synthetische vervangers, geen kunstmatige toevoegingen van welke aard dan ook.',
  },
  {
    icon: 'ri-ancient-gate-line',
    title: 'Eeuwenoud Recept',
    desc: 'Bereid naar het originele recept van onze voorouders, ongewijzigd doorgegeven door sjamanen en spirituele leiders door de eeuwen heen.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Puur Indigofera-extract',
    desc: 'Het blauw is gewonnen uit de indigofera plant — exact zoals onze voorouders dat deden, zonder chemische verwerking of kleurimitatie.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Geen Toevoegingen',
    desc: 'Geen vulstoffen, geen kleurstofcodes, geen conserveringsmiddelen. Wat jij krijgt is puur — zoals de natuur het bedoelde.',
  },
];

export const QualityPromise = () => {
  return (
    <section className="w-full py-12 px-6 lg:px-12 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a001a] via-[#0d0025] to-[#0a001a]" />
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://public.readdy.ai/ai/img_res/685743f482060a6eb64d1203156be498.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#050010]/70" />
      </div>

      {/* Top border glow */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-violet-500/50 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />

      <div className="relative z-10 max-w-[1440px] mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-500/10 border border-violet-500/25 mb-4">
            <i className="ri-award-line text-violet-400 text-xs" />
            <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase">Onze Belofte</span>
          </div>
          <h2 className="text-2xl lg:text-3xl font-black text-white mb-3">
            De{' '}
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              Kwaliteitsbelofte
            </span>{' '}
            van Blue Protect
          </h2>
          <p className="text-white/45 text-sm max-w-2xl mx-auto leading-relaxed">
            Terwijl concurrerende merken gebruik maken van goedkope synthetische vervangmiddelen en chemische toevoegingen,
            kiezen wij bewust voor de authentieke, pure formule van onze voorouders — zonder compromissen.
          </p>
        </div>

        {/* Promise Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {promises.map((p) => (
            <div
              key={p.title}
              className="relative bg-[#110020]/70 border border-violet-500/15 rounded-2xl p-5 group hover:border-violet-500/35 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-violet-500/10 border border-violet-500/20 mb-4 group-hover:bg-violet-500/20 transition-colors">
                <i className={`${p.icon} text-violet-400 text-lg`} />
              </div>
              <h3 className="text-white font-bold text-sm mb-2">{p.title}</h3>
              <p className="text-white/40 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom comparison strip */}
        <div className="bg-[#0d001f]/80 border border-violet-500/15 rounded-2xl p-6 flex flex-col lg:flex-row items-center gap-6">
          <div className="w-12 h-12 flex items-center justify-center shrink-0">
            <i className="ri-scales-3-line text-violet-400 text-2xl" />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <p className="text-white font-semibold text-sm mb-1">Blue Protect vs. andere merken</p>
            <p className="text-white/40 text-xs leading-relaxed max-w-2xl">
              Andere producten op de markt imiteren de kleur en geur van traditioneel blauw poeder met synthetische stoffen.
              Blue Protect gebruikt uitsluitend puur gewonnen indigofera-extract — het authentieke extract dat al eeuwen wordt
              gebruikt in sjamaanse beschermingsrituelen van onze voorouders. <span className="text-violet-400 font-medium">Geen namaak. Nooit.</span>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0 text-xs">
            <div className="flex items-center gap-2 bg-violet-500/10 border border-violet-500/25 rounded-xl px-4 py-2.5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-violet-400 text-sm" />
              </div>
              <span className="text-violet-300 font-medium whitespace-nowrap">Blue Protect — Puur</span>
            </div>
            <div className="flex items-center gap-2 bg-white/3 border border-white/8 rounded-xl px-4 py-2.5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-close-line text-white/30 text-sm" />
              </div>
              <span className="text-white/30 font-medium whitespace-nowrap">Concurrentie — Synthetisch</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
